import React from "react";
import { Check } from "lucide-react";
import { Order } from "../../../../interfaces/OrderObject";
import { formatInr } from "../../../../services/helpers/MoneyHelper";
import { billToLineViews } from "../../../../services/helpers/OrderBillHelper";
import BillDialog from "../../../shared/Bill/BillDialog";
import BillLines from "../../../shared/Bill/BillLines";
import DownloadBillButton from "../../../shared/Bill/DownloadBillButton";

interface DineInBillSheetProps {
  /** The dine-in order returned by generateBill; its `bill` is what's shown. */
  order: Order;
  tableNumber: number;
  /** Printed on the downloaded receipt. */
  businessName: string;
  onClose: () => void;
}

/**
 * Read-only receipt shown to the diner once the table is billed. Shares its
 * dialog shell and line list with the kitchen's bill review, so the two sides
 * of the counter read the same document. The only action is closing: by the
 * time this is up the session is already closed.
 */
const DineInBillSheet: React.FC<DineInBillSheetProps> = ({ order, tableNumber, businessName, onClose }) => {
  const { lines, charges } = billToLineViews(order.bill);

  return (
    <BillDialog ariaLabel={`Bill for table ${tableNumber}`} onClose={onClose}>
      <h3 className="bill__title">
        <Check size={16} /> Your bill · Table {tableNumber}
      </h3>
      <p className="bill__sub">This table is now closed</p>

      <BillLines lines={lines} charges={charges} />

      <div className="bill__total">
        <span>Total</span>
        <span className="bill__total-value">{formatInr(order.totalPrice ?? 0)}</span>
      </div>

      <div className="bill__actions">
        <DownloadBillButton order={order} businessName={businessName} />
        <button type="button" className="bill__btn bill__btn--primary" onClick={onClose}>
          Done
        </button>
      </div>
    </BillDialog>
  );
};

export default DineInBillSheet;
